/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import * as Linking from 'expo-linking';

export default {
  prefixes: [Linking.createURL('/')],
  config: {
    screens: {
      Root: {
        path: '/',
        screens: {
          Private: {
            initialRouteName: '/',
            screens: {
              VenueSelectionScreen: 'venueSelection',
              CommercesScreen: 'commerces',
              OrdersScreen: 'orders',
              OrderDetailsScreen: 'orderDetails',
              ConsumptionsReportsScreen: 'consumptionsReports',
              RefundsScreen: 'RefundsScreen',
              VisualizationScreen: 'visualization',
              BillingScreen: 'billing',
              ShoppingScreen: 'shopping',
              AccountBalanceScreen: 'accountBalance',
              CloverConnectionReportsScreen: 'cloverConnectionReports',
            },
          },
          Public: {
            screens: {
              LoginScreen: 'Login',
            },
          },
        },
      },
      NotFound: {
        path: '*',
      },
    },
  },
};
